import React from 'react';
import { InputText } from 'src/components/Layout/Forms';
import { RuleExpression } from 'src/data/types/descriptor';
import { parseJsonSafe } from 'src/utils/core';

export default function UserInteractivitySettingsRow(props: {
    components: {
        StandardOperatorsSelector: React.ReactNode,
        TextValueInput: React.ReactNode
    },
    expression: RuleExpression,
    onChange: (dataStr: string) => void
}) {
    const expData = parseJsonSafe(props.expression.data, { sel: '', url: '' } as Data);

    const updateSelectorData = (val: string) => {
        expData.sel = val;

        props.onChange(JSON.stringify(expData));
    }

    const updateUrlData = (val: string) => {
        expData.url = val;

        props.onChange(JSON.stringify(expData));
    }

    return <div>
        <InputText
            placeholder='Target element CSS selector'
            className='mt-2'
            value={expData.sel || ''}
            onChange={(e) => updateSelectorData(e.target.value)}
        />

        <InputText
            placeholder='URL template'
            className='mt-2'
            value={expData.url || ''}
            onChange={(e) => updateUrlData(e.target.value)}
        />

        <div className='mt-2'>
            {props.components.StandardOperatorsSelector}
        </div>

        {(props.expression.prop != 'uiact.elState' && props.expression.op != 'empty' && props.expression.op != 'empty_not') && <div className='mt-2'>
            {props.components.TextValueInput}
        </div>}
    </div>
}

type Data = {
    sel?: string;
    url?: string;
}